var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjLogoArena(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 151,
    viewBox: "0 0 165 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#proj-logo-arena_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.382 21.536h-5.114v101.316h5.114V21.536zm-15.25-3.277v107.314h5.113V18.259h-5.113zM54.56 21.536h-5.117v101.316h5.117V21.536zM85.478 10h-5.956v122.108h5.956V10zm9.635 4.503h-5.117v114.828h5.117V14.503zm-20.28 0h-5.117v114.828h5.117V14.503zM59.58 37.327v88.246h5.116V18.259H59.58v19.068z",
    fill: "#C20D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.642 84.033h14.037l-.744 3.971h-8.831v12.966h-4.466l.004-16.937zM50.44 100.97H64.5l-.745-3.975h-8.853v-2.52h5.69l.745-3.974h-6.435v-2.508h8.838l.745-3.97H50.44v16.947zm26.422-12.966h-5.18v3.409h5.21l-.03-3.409zm1.708-3.97c1.519 0 2.754 1.041 2.754 2.322v6.698c0 1.284-1.235 2.326-2.754 2.326h-6.888v5.582l-4.466.681v-17.61h11.358-.004zm15.106 3.97h-5.18v8.991h5.187l-.008-8.99zm1.708-3.97c1.518 0 2.754 1.041 2.754 2.322v12.28c0 1.28-1.236 2.326-2.754 2.326H86.79c-1.518 0-2.758-1.046-2.758-2.326v-12.28c0-1.28 1.24-2.323 2.758-2.323h8.6-.007zm5.485 16.936h14.063l-.744-3.975h-8.857v-2.52h5.694l.744-3.974h-6.438v-2.508h8.842l.744-3.97h-14.048v16.947zm26.422-6.483h-5.147v2.508h5.136l.011-2.508zm0-6.483h-5.147v2.508h5.136l.011-2.508zm4.466 3.01a1.98 1.98 0 01-.648 1.49 1.98 1.98 0 01.648 1.489v4.65c0 1.28-1.24 2.327-2.758 2.327h-11.32V84.033h11.313c1.518 0 2.757 1.042 2.757 2.323l.008 4.659zm-71.582-41.82h-7.759v8.853h7.76v-8.853zm2.471-5.352c2.728 0 4.946 1.489 4.946 3.301v12.954c0 1.82-2.233 3.305-4.946 3.305h-10.23v11.536l-7.42 1.489V43.842h17.65zm8.247 31.089H93.49l-1.25-5.352H78.314v-7.517h9.258l1.094-5.351H78.314v-7.517h13.553l1.622-5.352H70.893v31.089zm40.98-18.235h-7.759V43.842h-7.42v32.34l7.42-1.251V62.062h7.759v12.869l7.417 1.25V43.842h-7.417v12.854zm-82.146-.328l-1.69 5.583h3.38l-1.69-5.583zm3.39-12.54L43.12 74.915h-7.792l-2.297-7.603h-6.609l-4.045 11.533L14 79.91l12.34-36.068 6.777-.015zm102.168 12.54l1.689 5.583h-3.379l1.69-5.583zm-3.387-12.54l-10.007 31.088h7.797l2.281-7.588h6.609l4.049 11.536 8.373 1.05-12.333-36.072-6.769-.015z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "proj-logo-arena_svg__filter0_d",
    x: 0,
    y: 0,
    width: 165,
    height: 150.108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjLogoArena);
export default __webpack_public_path__ + "static/media/proj-logo-arena.ca162f46192e617b80d56a3c8f4ddb78.svg";
export { ForwardRef as ReactComponent };